export default {
  IMMIGRANT: {
    ID: 4,
    CAT_ORDER: 4,
    TYPE: "immigrant-insurance",
    TITLE: "Immigrant Insurance",
    DESC: "For immigrants to the USA.",
    ICON: "insurance-plans/immigrant-insurance-logo.png",
    IMAGE: "insurance-plans/immigrant-insurance-hero.png",
    LISTING: "/green-card-health-insurance/plans",
    QUOTE: "/green-card-insurance/quotes",
  },
  J1: {
    ID: 12,
    CAT_ORDER: 6,
    TYPE: "j1-insurance",
    TITLE: "J1 Visa Insurance",
    DESC: "For education, au-pairs, exchange visitors, and others.",
    ICON: "insurance-plans/j1-visa-insurance-logo.png",
    IMAGE: "insurance-plans/j1-visa-insurance-hero.png",
    LISTING: "/j1-visa-insurance/plans",
    QUOTE: "/j1-visa-health-insurance/quotes",
  },
  SCHENGEN: {
    ID: 14,
    CAT_ORDER: 3,
    TYPE: "schengen-insurance",
    TITLE: "Europe/Schengen Visa Insurance",
    DESC: "The Schengen Visa has made traveling to European Schengen countries much easier for international travelers.",
    ICON: "insurance-plans/europe-schengen-travel-insurance-logo.png",
    IMAGE: "insurance-plans/europe-schengen-travel-insurance-hero.png",
    LISTING: "/schengen-visa-insurance/plans",
    QUOTE: "/schengen-visa-insurance/quotes/",
  },
  STUDENT: {
    ID: 3,
    CAT_ORDER: 5,
    TYPE: "student-insurance",
    TITLE: "Student Visa Insurance",
    DESC: "For students studying abroad.",
    ICON: "insurance-plans/student-insurance-logo.png",
    IMAGE: "insurance-plans/student-insurance-hero.png",
    LISTING: "/student-health-insurance/plans",
    QUOTE: "/student-health-insurance/quotes/",
  },
  TRIP: {
    ID: 15,
    CAT_ORDER: 2,
    TYPE: "trip-insurance",
    TITLE: "Trip Insurance",
    DESC: "Covers medical expenses during your international trip.",
    ICON: "insurance-plans/trip-insurance.png",
    IMAGE: "insurance-plans/trip-insurance-hero.jpg",
    LISTING: "/trip-insurance/plans",
    QUOTE: "/trip-insurance/quotes/",
  },
  VISITOR: {
    ID: 1,
    CAT_ORDER: 1,
    TYPE: "visitor-insurance",
    TITLE: "Visitors & Travel Medical Insurance",
    DESC: "Covers medical expenses during your international trip.",
    ICON: "insurance-plans/visitors-insurance-logo.png",
    IMAGE: "insurance-plans/visitors-insurance-hero.png",
    LISTING: "/visitor-health-insurance/plans",
    QUOTE: "/visitor-health-insurance/quotes/",
  },
  PREEX: {
    ID: 34,
    CAT_ORDER: 7,
    TYPE: "preex-insurance",
    TITLE: "Pre-Existing Condition Insurance",
    DESC: "For travelers seeking medical insurance with limited pre-existing condition coverage.",
    ICON: "insurance-plans/product-pre-existing-conditions-icon.svg",
    IMAGE: "insurance-plans/product-pre-existing-conditions-insurance-hero.svg",
    LISTING: "/visitor-health-insurance/plans/pre-existing-conditions",
    QUOTE: "/pre-existing-conditions-insurance/quotes/",
  },
  ADDND: {
    ID: 31,
    CAT_ORDER: 8,
    TYPE: "add-insurance",
    TITLE: "AD & D Insurance",
    DESC: "For travelers and their families in the event of death or dismemberment.",
    ICON: "insurance-plans/product-icon-ad_d-insurance.png",
    IMAGE: "insurance-plans/product-ad-and-d-insurance-hero.svg",
    LISTING: "/ad-d-insurance/plans",
    QUOTE: "/ad-d-insurance/quotes/",
  },
  OPTSTUDENT: {
    ID: 18,
    CAT_ORDER: 9,
    TYPE: "opt-student-insurance",
    TITLE: "OPT Student Health Insurance",
    DESC: "For students visiting the U.S. on an Optional Practical Training (OPT) visa.",
    ICON: "insurance-plans/product-icon-opt-student-insurance.png",
    IMAGE: "insurance-plans/product-opt-student-health-insurance-hero.svg",
    LISTING: "/health-insurance-for-opt-students/plans",
    QUOTE: "/health-insurance-for-opt-students/quotes/",
  },
  MEDEVAC: {
    ID: 28,
    CAT_ORDER: 10,
    TYPE: "medical-evacuation-insurance",
    TITLE: "Medical Evacuation Insurance",
    DESC: "For those that require immediate evacuation, this benefit can cover related expenses.",
    ICON: "insurance-plans/medical-evacuation-insurance-icon.png",
    IMAGE: "insurance-plans/product-medical-evacuation-insurance-hero.svg",
    LISTING: "/emergency-medical-evacuation-insurance/plans",
    QUOTE: "/emergency-medical-evacuation-insurance/quotes/",
  },
  CRUISE: {
    ID: 32,
    CAT_ORDER: 11,
    TYPE: "cruise-insurance",
    TITLE: "Cruise Insurance",
    DESC: "For U.S. travelers embarking on a cruise.",
    ICON: "insurance-plans/product-icon-cruise-insurance.png",
    IMAGE: "insurance-plans/product-cruise-insurance-hero.svg",
    LISTING: "/cruise-insurance/plans",
    QUOTE: "/cruise-insurance/quotes/",
  },
  CFAR: {
    ID: 25,
    CAT_ORDER: 12,
    TYPE: "trip-insurance",
    TITLE: "Cancel for Any Reason Insurance",
    DESC: "For travelers who wish to cancel their trip for any reason and still recoup prepaid travel expenses.",
    ICON: "insurance-plans/product-icon-cancel-for-any-reason.png",
    IMAGE: "insurance-plans/product-cancel-for-any-reason.png-hero.svg",
    LISTING: "/trip-insurance/plans/?cancel-for-any-reason=1",
    QUOTE: "/trip-insurance/quotes/?cancel-for-any-reason=1",
  },
};
//Note if you are making changes in this file please verify affiliate quote wizard
